<template lang="html">
    <div>
        <span class="light mr-1 font-weight-400" v-if="showConnectedResevatios">Related bookings:</span>
        <template v-for="linkedBooking in linkedBookings">
            <template v-if="linkedBookingsContainCurrentBooking(linkedBooking) == false">
                <span
                    class="pointer reservationId"
                    :class="{'selected': currentBooking == linkedBooking}"
                    @click="clickReservation(lastArrayItem(linkedBooking))"
                >
                    {{`#${lastArrayItem(linkedBooking)}`}}
                </span>
            </template>

            <template v-else>
                <span :class="{'rebookGroup':linkedBooking.length > 1}">
                    <span
                        v-for="internalBooking in linkedBooking"
                        class="pointer reservationId"
                        :class="{
                            'selected': currentBooking == internalBooking,
                            'rebookParent': internalBooking != lastArrayItem(linkedBooking)
                        }"
                        v-tooltip="internalBooking != lastArrayItem(linkedBooking)?'Rebooked':null"
                        @click="clickReservation(internalBooking)"
                    >
                        #{{internalBooking}}
                    </span>
                </span>
            </template>
        </template>
    </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
    props: {
        reservation:{
            type: Object,
            required: true
        }
    },
    computed: {
        showConnectedResevatios() {
            const bookings = (this.reservation && this.reservation.linkedBookings) || [];

            return Array.isArray(bookings) && (bookings.length > 1 || (Array.isArray(bookings[0]) && bookings[0].length > 1));
        },
        currentBooking() {
            return this.reservation.id;
        },
        linkedBookings() {
            const bookings = (this.reservation && this.reservation.linkedBookings) || [];

            if (Array.isArray(bookings) && (bookings.length > 1 || (Array.isArray(bookings[0]) && bookings[0].length > 1))) {
                return bookings;
            }

            return [];
        },
    },
    methods: {
        ...mapActions([
            'openReservationById',
            'closeModal'
        ]),
        lastArrayItem(array) {
            return array[array.length - 1];
        },
        linkedBookingsContainCurrentBooking(linkedBookings) {
            return linkedBookings.some(l => l == this.currentBooking);
        },
        clickReservation(reservationId) {
            this.closeModal();
            this.openReservationById(reservationId);
            
            return false;
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "~@/assets/scss/_utility.scss";

    .rebookGroup {
        border: 1px solid $dark;
        padding: 3px 2px;
        border-radius: 5px;
    }

    .reservationId {
        @extend .bg-dark;
        padding: 0.2em 0.5em;
        margin: 0 3px;
        border-radius: 5px;
        font-size: 0.8em;
        color: $darker;

        &.selected {
            text-decoration: underline;
            color: #FFF !important;
        }

        &.rebookParent {
            color: $dark;
            @extend .bg-darker
        }
    }
</style>



// WEBPACK FOOTER //
// ConnectedReservations.vue?9d7148f4